import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { dragNDropConstants } from '../Globals/constants';
import { DropTarget } from 'react-dnd';
import Radium from 'radium';
import { semanticColors } from '../Globals/styles';

class EmployeeDropableTrashcan extends Component {
  render() {
    const { connectDropTarget, isOver } = this.props;

    return connectDropTarget(
      <div style={[styles.dropTarget, isOver && styles.isOver]}>
        <i style={styles.trashIcon} className="fa fa-trash-o" aria-hidden="true"></i>
        {isOver ? null : <span>Fjern medarbejder</span>}
      </div>
    )
  }
}


var styles = {
  dropTarget: {
    height: '42px',
    position: 'absolute',
    width: '100%',
    top: '0',
    left: '0',
    backgroundColor: semanticColors.dangerLighter,
    border: '1px dashed ' + semanticColors.danger,
    borderRadius: '2px',
    lineHeight: '40px',
    paddingLeft: '42px'
  },
  isOver: {
    backgroundColor: semanticColors.dangerLight
  },
  trashIcon: {
    fontSize: '20px',
    position: 'absolute',
    left: '10px',
    top: '10px',
    color: semanticColors.danger
  }
}

  EmployeeDropableTrashcan.propTypes = {
    isOver: PropTypes.bool.isRequired,
    rmEmployeeFromProject: PropTypes.func.isRequired
  };

const TrashcanEmployeeTarget = {
  drop(props, monitor) {
    props.rmEmployeeFromProject(monitor.getItem().employeeIndex, monitor.getItem().employeeId)
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

export default DropTarget(dragNDropConstants.EMPLOYEE, TrashcanEmployeeTarget, collect)(Radium(EmployeeDropableTrashcan));


// WEBPACK FOOTER //
// ./src/App/Common/employeeDropableTrashcan.jsx